const DATE_FMT_LONG: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' }
const DATE_FMT_SHORT: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' }
const DATE_FMT_TIME: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
}

function isDateOnly(iso: string): boolean {
  return iso.length <= 10 && !iso.includes('T')
}

export function fmtDate(
  iso: string | null | undefined,
  opts: Intl.DateTimeFormatOptions = DATE_FMT_LONG
): string {
  if (!iso) {
    return '—'
  }
  // Date-only strings (e.g. session.date "2026-07-04") represent a calendar
  // day, not a UTC instant. Format them in UTC so the displayed date matches
  // the stored value regardless of the user's local timezone.
  const options = isDateOnly(iso) ? { ...opts, timeZone: 'UTC' } : opts
  return new Date(iso).toLocaleDateString('en-CA', options)
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return '—'
  }
  const options = isDateOnly(iso)
    ? { ...DATE_FMT_TIME, timeZone: 'UTC' }
    : DATE_FMT_TIME
  return new Date(iso).toLocaleString('en-CA', options)
}

// Time-only strings from the API (e.g. "09:00" or "09:00:00") are wall-clock
// times in the class timezone, not UTC instants. Format them directly instead
// of going through Date to avoid timezone shifts.
export function fmtTime(time: string | null | undefined): string {
  if (!time) {
    return '—'
  }
  const match = /^(\d{1,2}):(\d{2})/.exec(time)
  if (!match) {
    return time
  }
  const hours = Number(match[1])
  const minutes = match[2]
  const period = hours >= 12 ? 'PM' : 'AM'
  const hour12 = hours % 12 || 12
  return `${hour12}:${minutes} ${period}`
}

export function fmtTimeRange(
  start: string | null | undefined,
  end: string | null | undefined
): string {
  if (!start && !end) {
    return '—'
  }
  if (!start) {
    return fmtTime(end)
  }
  if (!end) {
    return fmtTime(start)
  }
  return `${fmtTime(start)} – ${fmtTime(end)}`
}

export { DATE_FMT_LONG, DATE_FMT_SHORT }
